/**
 * Ingatlan adatlap adatmegjelenítő komponens
 *
 * @author Erik Banhalmi 2017.06.19.
 */
import login from './../../../frame/header/login/login.module';
import favourite from './../../favourites/service/favourites-service.module';

const MODULE_NAME = 'realEstateDataDisplayer';
// const TERRACE_TYPES = ['balcony', 'frenchBalcony', 'terrace', 'roofTerrace', 'loggia'];
const MOBILE_PX = 992;

class RealEstateDataDisplayerController {
	constructor($rootScope, loginService, favouriteService, $translate, $q, $timeout) {
		'ngInject';
		this.$rootScope = $rootScope;
		this.loginService = loginService;
		this.favouriteService = favouriteService;
		this.usedLanguage = $translate.use();
		$rootScope.$on('$translateChangeEnd', (event, args) => {
			this.usedLanguage = args.language;
		});
		this.$translate = $translate;
		this.separatedToilet = false;
		this.separatedBathroom = false;
		this.toiletAndBathroom = false;
		this.$q = $q;
		this.$timeout = $timeout;
	}
	$onInit() {
		this.isLoggedIn = this.$rootScope.isLoggedIn;
		if (this.isMobile()) {
			this.hideRooms = true;
			this.hideThird = true;
		}
	}
	submitAgentMessageForm(event) {
		this.onMessageToAgent({
			$event: {
				message: event.message
			}
		});
	}
	$onChanges(changeObject) {
		if (changeObject.data && !changeObject.data.isFirstChange()) {
			this.realEstateData = angular.copy(this.data);
			// propertyDTO
			if (this.realEstateData.propertyData && this.realEstateData.propertyData.balcony) {
				this.transformArray(this.realEstateData.propertyData.balcony, 'propertyData', 'balcony');
			}
			if (this.realEstateData.propertyData && this.realEstateData.propertyData.heating) {
				this.transformArray(this.realEstateData.propertyData.heating, 'propertyData', 'heating');
			}
			if (this.realEstateData.propertyData && this.realEstateData.propertyData.heatDissipation) {
				this.transformArray(this.realEstateData.propertyData.heatDissipation, 'propertyData', 'heatDissipation');
			}
			if (this.realEstateData.propertyData && this.realEstateData.propertyData.approach) {
				this.transformArray(this.realEstateData.propertyData.approach, 'propertyData', 'approach');
			}
			// buildingData
			if (this.realEstateData.buildingData && this.realEstateData.buildingData.parkingOption) {
				this.transformArray(this.realEstateData.buildingData.parkingOption, 'buildingData', 'parkingOption');
			}
			if (this.realEstateData.buildingData && this.realEstateData.buildingData.elevator) {
				this.transformArray(this.realEstateData.buildingData.elevator, 'buildingData', 'elevator');
			}
		}
		if (changeObject.formError && !changeObject.formError.isFirstChange()) {
			this.formBackendError = angular.copy(this.formError);
		}
		if (changeObject.interestResponse) {
			this.interestRestResponse = angular.copy(this.interestResponse);
		}
	}
	isMobile() {
		return window.innerWidth < MOBILE_PX;
	}

	transformArray(arr, parentKey, key) {
		if (Array.isArray(arr) && arr.length) {
			this.translateArray(arr, response => {
				this[key] = response;
			});
		} else {
			delete this.realEstateData[parentKey][key];
		}
	}

	likeOrLogin($event) {
		if (this.isLoggedIn) {
			window.dataLayer.push({
				event: 'pageInit',
				pageType: 'Ingatlan végoldal',
				propertyID: this.realEstateData.comissionId
			});
			this.setLiked();
		} else {
			this.showLogin($event);
		}
	}

	setLiked() {
		this.favouriteService
			.setFavourite(this.realEstateData.comissionId)
			.then(() => {
				this.realEstateData.liked = !this.realEstateData.liked;
			})
			.catch(error => {
				console.log(error);
			});
	}

	showLogin($event) {
		this.loginService.openLoginForm($event);
	}

	sendInterestOnDataDisplayer($event) {
		this.sendInterest({ $event });
	}

	translateArray(array, callback) {
		this.$timeout(() => {
			let retValue = [];
			let promises = [];
			array.forEach(e => {
				promises.push(this.$translate('AADAT.' + e));
			});
			this.$q.all(promises).then(
				data => {
					retValue = data.join(', ');
					callback(retValue);
				},
				err => {
					console.log(err);
				}
			);
		});
	}

	getAddress() {
		let retValue = '';
		if (this.realEstateData) {
			if (this.realEstateData.city) {
				retValue += this.realEstateData.city;
			}
			if (this.realEstateData.address) {
				retValue += retValue == '' ? this.realEstateData.address : ', ' + this.realEstateData.address;
			}
		}
		return retValue;
	}

	typeOfValueIsStringOrBoolean(value) {
		return typeof value == 'string' || typeof value == 'boolean';
	}

	typeOfValueIsNumber(value) {
		return typeof value == 'number';
	}

	checkNotEmpty(thing) {
		if (typeof thing == 'object') {
			return Object.keys(thing).filter(key => !!thing[key]).length;
		} else if (Array.isArray(thing)) {
			return thing.filter(item => !!item).length;
		} else {
			return false;
		}
	}
}

export default angular.module(MODULE_NAME, [login, favourite]).component('realEstateDataDisplayer', {
	controller: RealEstateDataDisplayerController,
	templateUrl: 'real-estate-data-displayer.html',
	bindings: {
		data: '<',
		formError: '<',
		onMessageToAgent: '&',
		kNumber: '<',
		sendInterest: '&',
		interestResponse: '<'
	}
}).name;


